import { makeStyles } from "@material-ui/core/styles";

export const topfileStyles = makeStyles((theme) => ({
  paperContainer: {
    display: "flex",
    width: "100%",
    padding: theme.spacing(2),
    justifyContent: "space-between",
    flexDirection: "column",
    overflow: "hidden",
  },
  listContainer: {
    display: "flex",
    width: "100%",
    overflowX: "auto",
    minWidth: 500,
    alignItems: "center",
    listStyle: "none",
    padding: 0,
    paddingBottom: theme.spacing(2),
    "& li:not(:last-child)": {
      marginRight: theme.spacing(2),
    },
  },
  item: {
    display: "inline-block",
    width: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 350,
  },
}));
